import { addMinutes, format } from 'date-fns';
import React from 'react';

import useTranslation from '@hooks/useTranslation';

import type { IComment } from '@model/actionItem';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import style from './style.module.scss';

interface IProps {
  commentItem: IComment;
  userTimezone: number;
}

const SystemMessage: React.FC<IProps> = ({ commentItem, userTimezone }) => {
  const { t } = useTranslation();

  const { data: profileData } = useUserProfileQuery();
  const dateFormat = `${profileData?.dateFormat.date} ${profileData?.dateFormat.time}`;

  const { time_created, comment, postscript, status_changed } = commentItem;

  return (
    <div className={style.systemMessage}>
      <div className={style.systemMessageInfo}>
        <div className={style.systemMessageTitle}>
          {status_changed ? (
            <>
              {t('The status was changed to')} <b className={style.statusChanged}>{t(status_changed)}</b>
            </>
          ) : (
            comment
          )}
        </div>
        <span className={style.systemMessageDate}>
          {format(addMinutes(time_created, userTimezone), dateFormat)}
        </span>
      </div>
      {!!postscript && (
        <div className={style.systemMessagePostscript} dangerouslySetInnerHTML={{ __html: postscript }} />
      )}
    </div>
  );
};

export default SystemMessage;
